import { useTranslation } from "react-i18next";
import { sort } from "../../utils/selectValues";
import BasicSelect from "../elements/BasicSelect";
interface PropertySortingProps {
  value: any;
  setValue: any;
}

const PropertySorting = ({ value, setValue }: PropertySortingProps) => {
  const { t } = useTranslation()
  return (
    <BasicSelect
      value={value}
      setValue={setValue}
      selectValues={sort}
      selectStyle="outlined"
      label={t('overview.sort_by')}
    />
  );
};

export default PropertySorting;
